import { Box, CircularProgress, Divider, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const NotificationHeader = ({ loading }: { loading: boolean }) => {
    const { t } = useTranslation();

    return (
        <>
            <Box px={1} py={1}>
                <Typography
                    sx={{
                        fontSize: "18px",
                        fontFamily: "Montserrat",
                    }}
                >
                    {t("notification.title")}
                </Typography>
            </Box>
            <Divider />
            {loading && (
                <Box px={2} py={3} display="flex" justifyContent="center">
                    <CircularProgress size={24} />
                </Box>
            )}
        </>
    );
};

export default NotificationHeader;
